export default __webpack_public_path__ + "static/media/iconFeatures.50c07118.svg";